import { AppDate } from "../../utils/date-utils/AppDate.ts";
import { Engagement } from "../engagement.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";
import {OrganizationSerializer} from "@models/serializers/organizationSerializer.ts";
import {TeamMemberSerializer} from "@models/serializers/teamMemberSerializer.ts";
import {NotebookSerializer} from "@models/serializers/notebookSerializer.ts";
import {TodoListSerializer} from "@models/serializers/todoListSerializer.ts";
import { ScheduleSerializer } from "./scheduleSerializer.ts";

export class EngagementSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const engagement = new Engagement();

        this._copyAttributes(engagement, data);

        if (data.service_provider) {
            const orgSerializer = new OrganizationSerializer();
            engagement.service_provider = orgSerializer.deserialize(data.service_provider);
        }

        if (data.client) {
            const orgSerializer = new OrganizationSerializer();
            engagement.client = orgSerializer.deserialize(data.client);
        }

        if (data.notebook) {
            const nbSerializer = new NotebookSerializer();
            engagement.notebook = nbSerializer.deserialize(data.notebook);
        }

        if (data.todo_list) {
            const tlSerializer = new TodoListSerializer();
            engagement.todo_list = tlSerializer.deserialize(data.todo_list);
        }

        if (data.engagement_manager) {
            const tmSerializer = new TeamMemberSerializer();
            engagement.engagement_manager = tmSerializer.deserialize(data.engagement_manager);
        }

        // Parsed explicitly because `_copyAttributes` only converts a field that is already
        // an AppDate, and these start as null. Null is the meaningful value here: it is the
        // difference between "never opened" and "opened at an unknown time", and the column
        // renders a dash for it.
        for (const key of ["last_viewed", "update_date"] as const) {
            if (data[key]) {
                const parsed = new AppDate();
                parsed.parseDate(data[key]);
                engagement[key] = parsed;
            }
        }

        if (data.client_success_manager) {
            const tmSerializer = new TeamMemberSerializer();
            engagement.client_success_manager = tmSerializer.deserialize(data.client_success_manager);
        }

        if (data.schedule) {
            const schSerializer = new ScheduleSerializer();
            engagement.schedule = schSerializer.deserialize(data.schedule)
        }

        return engagement;

    }

}
